import { render } from "./cell_collect_status.vue?vue&type=template&id=f1ab56da"
import script from "./cell_collect_status.vue?vue&type=script&lang=ts"
export * from "./cell_collect_status.vue?vue&type=script&lang=ts"

import "./cell_collect_status.vue?vue&type=style&index=0&id=f1ab56da&lang=less"
script.render = render

export default script